import { QueryClientProvider } from '@tanstack/react-query'
import { createMemoryHistory, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ThemeProvider, TooltipProvider } from '@aeris/ui'

import './app.css'
import { ShellGate } from './components/shell-gate.tsx'
import { AuthProvider } from './lib/auth.tsx'
import { WindowRouterFactoryContext } from './lib/desktop/window-router.ts'
import { createQueryClient } from './lib/query-client.ts'
import { registerServiceWorker } from './lib/service-worker.ts'
import { bootShellFrame, ShellFrameContext } from './lib/shell-frame.ts'
import { listenForStaleChunks } from './lib/stale-chunk.ts'
import { createAppRouter } from './router.tsx'

// F211: as listas se atualizam sozinhas — ver `lib/query-client.ts`.
const queryClient = createQueryClient()

registerServiceWorker()
listenForStaleChunks()

/*
 * O roteador DESTA página, criado aqui e não no módulo de rotas (F138): as
 * janelas do Modo PC criam os delas sobre a mesma árvore, e um roteador de
 * módulo seria um só para todo mundo.
 */
const router = createAppRouter()

/** O roteador de uma janela do Modo PC: a mesma árvore, a navegação dela. */
const windowRouter = (initialHref: string) => {
  const history = createMemoryHistory({ initialEntries: [initialHref] })
  return { router: createAppRouter({ history, preload: false }), history }
}

const container = document.getElementById('root')
if (!container) throw new Error('Elemento #root não encontrado')

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        {/* Por fora do ShellGate: a tela "Qual é o seu Aeris?" tem o
            ThemeToggle, que é um Tooltip. Com o provider por dentro, a primeira
            abertura do aplicativo instalado quebrava e pintava só o fundo. */}
        <TooltipProvider delayDuration={300}>
          {/* Antes do AuthProvider: no aplicativo instalado, perguntar a senha
              de um servidor que ninguém configurou é mandar a pessoa para um
              beco. Num navegador este portão não faz nada. */}
          <ShellGate>
            <AuthProvider>
              <ShellFrameContext value={bootShellFrame()}>
                <WindowRouterFactoryContext value={windowRouter}>
                  <RouterProvider router={router} />
                </WindowRouterFactoryContext>
              </ShellFrameContext>
            </AuthProvider>
          </ShellGate>
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>
)
